import * as React from 'react';
import './ReturnsRow.scss';
import localeFormatingInstance from 'src/translation/localeFormating';
import { IEligibleItem } from 'src/services/returns/typings';
import isNumber from 'src/utils/isNumber';
import hasComma from 'src/utils/hasComma';
import IconMessage from 'src/components/common/IconMessage';
import AlertCustom from 'src/components/common/AlertCustom';
interface IReturnsRowProps {
  partToReturn: IEligibleItem;
  removeItemFromReturn: (id: number) => void;
  editPartFromReturnList: (part: IEligibleItem) => void;
  isShowTableHistoryInfoForRow:boolean;
  t?: any;
}

const ReturnsRow: React.FC<IReturnsRowProps> = props => {
  const {
    partToReturn,
    removeItemFromReturn,
    editPartFromReturnList,
    isShowTableHistoryInfoForRow,
    t
  } = props;

  const [returnQty, setReturnQty] = React.useState<string>(
    String(partToReturn.returnQuantity)
  );
  const [reason, setReturnReason] = React.useState<string>(partToReturn.reason);
  const [isShowHistoryInfo, setIsShowHistoryInfo] = React.useState<boolean>(false);

  React.useEffect(() => {
    editPartFromReturnList({
      ...partToReturn,
      returnQuantity: Number(returnQty),
      reason
    });
  }, [returnQty, reason]);

  React.useEffect(()=>{
    if(partToReturn.noOfTimesPartInvoicedInLast90Days>1){
      setIsShowHistoryInfo(true);
    }
  },[])

  const handleChangeReturnQty = (e: any) => {
    const qty = e.target.value;

    if (isNumber(qty) && qty <= partToReturn.availableQuantity) {
      setReturnQty(qty);
    }
  };

  const handleChangeReason = (e: any) => {
    if (!hasComma(e.target.value)) {
      setReturnReason(e.target.value);
    }
  };
  const handleCloseAlert = () => {
    setIsShowHistoryInfo(false)
  }

  return (
    <div className="rp-returns-row">
      <div className="container-fluid">
        <div className="row rp-returns-row-part-container">
          <div className="col-12">
            <div className="rp-returns-row-part">
              <p className="rp-returns-row-part-title">
                {partToReturn.partNumber}
              </p>
              <i
                onClick={() => removeItemFromReturn(partToReturn.id)}
                className="rpds-remove-circle rp-returns-row-part-icon"
              />
            </div>
          </div>
        </div>
        <div className="row rp-returns-row-content">
          <div className="col-12">
            <div className="row">
              <div className="col-3">
                <p className="rp-returns-row-content-header">
                  {t('myReturns.invoiceNo')}
                </p>
              </div>
              <div className="col-3">
                <p className="rp-returns-row-content-header">
                  {t('myReturns.invoiceDate')}
                </p>
              </div>
              <div className="col-3">
                <p className="rp-returns-row-content-header">
                  {t('myReturns.price')}
                </p>
              </div>
              <div className="col-3">
                <p className="rp-returns-row-content-header">
                  {t('myReturns.mobile.rFee')}
                </p>
              </div>
            </div>
            <div className="row rp-returns-row-content-data">
              <div className="col-3">
                <p>{partToReturn.invoiceNumber}</p>
              </div>
              <div className="col-3">
                <p>{partToReturn.invoiceDate}</p>
              </div>
              <div className="col-3">
                <p>
                  {localeFormatingInstance.formatCurrency(partToReturn.price)}
                  {partToReturn.hasCoreIncluded && (
                    <IconMessage
                      icon={'rpds-error'}
                      isIconInline={true}
                      message={'This price includes a Core Charge'}
                    />
                  )}
                </p>
              </div>
              <div className="col-3">
                <p>{partToReturn.returnFee}</p>
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <p className="rp-returns-row-content-header">
                  {t('myReturns.returnQty')}
                </p>
              </div>
              <div className="col-8">
                <p className="rp-returns-row-content-header">
                  {t('myReturns.reasonReference')}
                </p>
              </div>
            </div>
            <div className="row">
              <div className="col-4">
                <input
                  type="text"
                  value={returnQty}
                  onChange={handleChangeReturnQty}
                  className="rp-returns-row-content-input qty"
                />
                / {partToReturn.availableQuantity}
              </div>
              <div className="col-8">
                <input
                  type="text"
                  value={reason}
                  onChange={handleChangeReason}
                  className="rp-returns-row-content-input reason"
                  maxLength={60}
                />
              </div>
            </div>
          </div>
        </div>
        {isShowHistoryInfo && isShowTableHistoryInfoForRow &&
        <div className="row rp-returns-row-part-container">
          <div className="col-12">
            <div className="rp-returns-row-part">
            <AlertCustom
              type="info"
              styleClass="rp-return-row-history-info--alert"
              icon={'icon="rpds-check-circle"'}
              handleCloseAlert={handleCloseAlert}
              removeItemFromReturn={removeItemFromReturn}
              handleTableCloseAlert={null}
              removeAllPartsFromCart={null}
              id={partToReturn.id}

              message={`You have used part ${partToReturn.partNumber} recently ${partToReturn.noOfTimesPartInvoicedInLast90Days} times with ${partToReturn.partQtyOrdered} quantity`}
            />
            </div>
          </div>
        </div>
        }
      </div>
    </div>
  );
};

export default ReturnsRow;
